import React from 'react';
import { motion } from 'framer-motion';
import { Bell } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useNotifications } from '@/contexts/notification-context';
import { useLocalStorageState } from '@/hooks/ai-agents/useLocalStorageState';
import { cn } from '@/lib/utils';

const NotificationButton = () => {
  const navigate = useNavigate();
  const { unreadCount } = useNotifications();
  const { isModalOpen, closeModal } = useLocalStorageState();
  
  const handleClick = () => {
    // Close chat modal if it's open (same pattern as other navbar buttons)
    if (isModalOpen) {
      closeModal();
    }
    navigate('/notifications');
  };
  
  return (
    <motion.div
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      className="relative"
    >
      <button
        onClick={handleClick}
        className={`
          h-9 w-9 rounded-lg group p-0
          flex items-center justify-center 
          bg-gradient-to-br from-blue-500 to-purple-600
          hover:from-blue-600 hover:to-purple-700
          transition-all duration-200
          shadow-md hover:shadow-lg
        `}
        aria-label="Notifications"
      >
        <motion.div
          whileHover={{ scale: 1.1, rotate: 15 }}
          transition={{ duration: 0.3 }}
        >
          <Bell size={18} className="text-white" />
        </motion.div>
      </button>
      
      {/* Notification badge - positioned relative to the motion.div container */}
      {unreadCount > 0 && (
        <span className={cn(
          "absolute -top-1 -right-1 min-w-[18px] h-[18px]",
          "flex items-center justify-center",
          "text-[10px] font-semibold",
          "bg-gradient-to-r from-red-500 to-red-600",
          "text-white rounded-full shadow-sm",
          "border border-white/40",
          "z-10"
        )}>
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </motion.div>
  );
};

export default NotificationButton; 